const UPLOAD_TIMEOUT_MS = 8000;
const DECODE_TIMEOUT_MS = 3000;

export const canvasToBlob = (canvas) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Canvas could not be converted to a PNG'));
        }
      },
      'image/png',
      1.0
    );
  });

export const blobToDataUrl = (blob) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve(typeof reader.result === 'string' ? reader.result : null);
    reader.onerror = () => resolve(null);
    reader.readAsDataURL(blob);
  });

export const uploadBoardingPass = async (blob) => {
  const wpUrl = process.env.REACT_APP_WORDPRESS_URL;
  if (!wpUrl) return null;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), UPLOAD_TIMEOUT_MS);

  try {
    const response = await fetch(`${wpUrl}/wp-json/l62/v1/boarding-pass`, {
      method: 'POST',
      headers: { 'Content-Type': 'image/png' },
      body: blob,
      signal: controller.signal
    });

    if (!response.ok) return null;

    const data = await response.json();
    return data?.url || null;
  } catch (error) {
    return null;
  } finally {
    clearTimeout(timeout);
  }
};

export const createShareFile = (blob, patchId) => {
  if (typeof File !== 'function') return null;

  try {
    return new File([blob], `level-62-boarding-pass-${patchId || 'pass'}.png`, {
      type: 'image/png'
    });
  } catch (error) {
    return null;
  }
};

export const canShareFiles = (file) => {
  if (typeof navigator === 'undefined') return false;
  if (typeof navigator.share !== 'function') return false;
  if (typeof navigator.canShare !== 'function') return false;

  try {
    return navigator.canShare({ files: [file] });
  } catch (error) {
    return false;
  }
};

export const shareFile = async (file) => {
  try {
    await navigator.share({ files: [file] });
    return true;
  } catch (error) {
    return false;
  }
};

export const loadShareableImage = (url) =>
  new Promise((resolve) => {
    const img = new Image();
    let settled = false;

    const finish = (result) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      img.onload = null;
      img.onerror = null;
      resolve(result);
    };

    const timeout = setTimeout(() => {
      img.src = '';
      finish(null);
    }, DECODE_TIMEOUT_MS);

    img.onload = () => finish(url);
    img.onerror = () => finish(null);
    img.src = url;
  });
